module.exports = __webpack_public_path__ + "media/images/flags/64/British-Virgin-Islands-d954ffda14c27c8bac361531b19892b7.png";